// Measures whose edited notes don't match the bar length — under-filled OR overflowing.
import type { NoteEvent } from "../../types/domain";
import { beatsOf } from "../notation/beatGrouping";

export function incompleteMeasures(
  notesByMeasure: Record<number, NoteEvent[]>,
  capOf: (m: number) => number,
): Set<number> {
  const out = new Set<number>();
  for (const k in notesByMeasure) {
    const m = +k;
    const notes = notesByMeasure[m];
    if (!notes || !notes.length) continue;
    const b = beatsOf(notes), cap = capOf(m);
    if (b < cap - 1e-6 || b > cap + 1e-6) out.add(m);   // under-filled or overflowing bar
  }
  return out;
}
